
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/artist-remuneration",
      function () {
        return require("private-next-pages/artist-remuneration/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/artist-remuneration"])
      });
    }
  